import { render, staticRenderFns } from "./BlackFridayRulePopup.vue?vue&type=template&id=7055fa25&scoped=true&"
import script from "./BlackFridayRulePopup.vue?vue&type=script&lang=js&"
export * from "./BlackFridayRulePopup.vue?vue&type=script&lang=js&"
import style0 from "./BlackFridayRulePopup.vue?vue&type=style&index=0&id=7055fa25&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7055fa25",
  null
  
)

export default component.exports